import React from 'react';
import { Link } from 'gatsby';
import parse from 'html-react-parser';
import { useWipAuthors } from '../../../hooks/use-wip-authors';
import { getPostAuthors } from '../../../model/author';
import { getPostPath } from '../../../model/post';
import { LabelName } from '../../articles';

const PostCard = ({ post: { title, slug, excerpt, tghpwipArticleAuthor: authorIds } }) => {
  const allAuthors = useWipAuthors();
  const postAuthors = getPostAuthors(authorIds, allAuthors);

  return (
    <article className="article-card-wide">
      <LabelName label="Essay by" names={postAuthors} />
      <div className="article-card-wide__body">
        <Link to={getPostPath(slug)}>
          <h3 className="article-card-wide__body-title">{title}</h3>
        </Link>
        <div className="article-card-wide__body-excerpt">{parse(excerpt)}</div>
        <Link to={getPostPath(slug)} className="article-card-wide__body-read-more">
          Read more {parse(`&#8594`)}
        </Link>
      </div>
    </article>
  );
};

export default PostCard;
